import { useSearchParams } from 'react-router-dom';
import { Page } from '@/components/Page';
import { PageHeader } from '@/components/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { InvitesTab } from './InvitesTab';
import { UsersTab } from './UsersTab';

type UsersPageTab = 'users' | 'invites';

/** Admin-only (wrapped in AdminRoute). Active tab lives in ?tab= so links and reloads keep it. */
export function UsersPage(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: UsersPageTab = searchParams.get('tab') === 'invites' ? 'invites' : 'users';

  function onTabChange(next: string): void {
    const params = new URLSearchParams();
    if (next === 'invites') params.set('tab', 'invites');
    setSearchParams(params, { replace: true });
  }

  return (
    <Page width="6xl">
      <PageHeader title="Users" hint="Invite people, change roles and deactivate accounts. Deactivated people keep their history." />
      <Tabs value={tab} onValueChange={onTabChange}>
        <TabsList>
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="invites">Invites</TabsTrigger>
        </TabsList>
        <TabsContent value="users">
          <UsersTab />
        </TabsContent>
        <TabsContent value="invites">
          <InvitesTab />
        </TabsContent>
      </Tabs>
    </Page>
  );
}
